<div class="flex column start center g-16">
	<h4>{{ 'account.purchases_history' | translateWithKeys }}</h4>

	<table mat-table [dataSource]="data">
		@for (column of columns; track $index) {
			<ng-container [matColumnDef]="column">
				<th mat-header-cell *matHeaderCellDef><p class="body2">{{ columnLabels[$index] | translateWithKeys }}</p></th>
				<td mat-cell *matCellDef="let element">
					@if (columnsTemplates[$index] !== null && columnsTemplates[$index] !== undefined) {
						<ng-container [ngTemplateOutlet]="columnsTemplates[$index]" [ngTemplateOutletContext]="{ item: element }"></ng-container>
					} @else {
						<p class="body2">{{ element[column] }}</p>
					}
				</td>
			</ng-container>
		}

		<tr mat-header-row *matHeaderRowDef="columns"></tr>
  		<tr mat-row *matRowDef="let row; columns: columns;"></tr>
	</table>
</div>

<ng-template #receiptTemplate let-item="item">
	<p class="receipt-font"># {{ item?.receipt }}</p>
</ng-template>

<ng-template #amountTemplate let-item="item">
	<p class="body2">{{ item?.amount | currency }}</p>
</ng-template>

<ng-template #dateTemplate let-item="item">
	<p class="body2">{{ item?.date | appDate }}</p>
</ng-template>

<ng-template #cardTemplate let-item="item">
	<div class="cc-container">
		<img src="../../../assets/credit-cards/visa placeholder.png" alt="...">
		<p class="body2">•••• 1234</p>
	</div>
</ng-template>

<ng-template #paymentTemplate let-item="item">
	<app-purchase-label [type]="item?.payment_status"></app-purchase-label>
</ng-template>

<ng-template #downloadTemplate let-item="item">
	<mat-icon svgIcon="download" class="download-icon pointer" (click)="downloadReceipt()"></mat-icon>
</ng-template>
